import {TargetBlank} from '@wandb/weave/common/util/links';
import {Button} from '@wandb/weave/components/Button';
import {Icon} from '@wandb/weave/components/Icon';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React, {useState} from 'react';

import {trackWorkspaceModes} from '../../services/analytics/workspaceModesEvents';
import {lookupDocUrl} from '../../util/doc_urls';
import {useUpdateShouldAutoGeneratePanels} from '../WorkspaceDrawer/Settings/hooks';
import {WorkspaceModeOption} from './WorkspaceModeOption';

export const WorkspaceModePrompt = () => {
  const [selectedMode, setSelectedMode] = useState<'auto' | 'manual'>();
  const updateShouldAutoGeneratePanels = useUpdateShouldAutoGeneratePanels();

  return (
    <TailwindContents>
      <div className="flex h-full w-full justify-center py-[9rem]">
        <form className="flex flex-col items-center gap-24">
          <div className="text-center">
            <p id="select-mode-label" className="text-xl font-semibold">
              Select a workspace mode
            </p>
            <p className="mt-8 text-wb-text-secondary">
              Learn more about workspace modes{' '}
              <TargetBlank
                href={lookupDocUrl('workspaceModes')}
                onClick={() => {
                  trackWorkspaceModes({
                    action: 'Docs link clicked',
                    location: 'Select workspace mode prompt',
                  });
                }}>
                in W&B docs
              </TargetBlank>
              .
            </p>
          </div>
          <div
            role="radiogroup"
            aria-labelledby="select-mode-label"
            className="flex flex-wrap justify-center gap-12">
            <WorkspaceModeOption
              isSelected={selectedMode === 'auto'}
              onClick={() => setSelectedMode('auto')}
              color="cactus"
              icon="automated-workspace"
              label="Automated workspace"
              description="Automatically generate panels for all keys logged in this project. Recommended if you would like all available data to be visualized by default."
            />
            <WorkspaceModeOption
              isSelected={selectedMode === 'manual'}
              onClick={() => setSelectedMode('manual')}
              color="purple"
              icon="draft"
              label="Manual workspace"
              description="Start from a blank slate and manually curate visualizations for your workspace. Recommended when only a subset of logged keys are relevant to your analysis."
            />
          </div>
          {selectedMode !== undefined && (
            <Button
              data-test="submit-ws-mode-btn"
              className="w-full gap-5"
              data-dd-action-name={
                selectedMode === 'auto'
                  ? 'Generate automated workspace'
                  : 'Get started'
              }
              onClick={() => {
                updateShouldAutoGeneratePanels(selectedMode === 'auto');
                trackWorkspaceModes({
                  action:
                    selectedMode === 'auto'
                      ? 'Auto workspace created'
                      : 'Manual workspace created',
                });
              }}>
              <>
                {selectedMode === 'auto'
                  ? 'Generate automated workspace'
                  : 'Get started'}
                <Icon name="forward-next" />
              </>
            </Button>
          )}
        </form>
      </div>
    </TailwindContents>
  );
};
